import React, { useState, useEffect } from 'react';

// Route
import { useParams } from 'react-router-dom';

// Client
import { client } from '../client';

// Component
import MasonryLayout from './MasonryLayout';
import Spinner from './Spinner';

// Utils
import { searchQuery, feedQuery } from '../utils/data';

const Feed = () => {

  const [loading, setLoading] = useState(true);
  const [pins, setPins] = useState(null);
  const { categoryId } = useParams();

  useEffect(() => {
    setLoading(true);
    if (categoryId) {
      const query = searchQuery(categoryId);
      client.fetch(query)
      .then((data) => {
        setPins(data);
        setLoading(false);
      })
    } else {
      client.fetch(feedQuery)
      .then((data) => {
        setPins(data);
        setLoading(false);
      });
    }
  }, [ categoryId ]);

  if (loading) {
    return (<Spinner message="We are adding new ideas to your feed!" />)
  }

  if (!pins?.length) {
    return (<h2 className="dark:text-white">
      No Pins Available!
    </h2>);
  }

  return (
    <div>
      { pins && <MasonryLayout pins={pins} />}
    </div>
  )
}

export default Feed;